import { TradingModal } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import type { CreatePricingIndexPayload } from '@/api/services/settings/pricing-indices.service';

import PricingIndexForm from '../forms/PricingIndexForm';

import usePricingIndexForm from '../../hooks/utils/usePricingIndexForm';

type Props = {
  setIsOpen: (isOpen: boolean) => void;
  handleCreatePricingIndex: (payload: CreatePricingIndexPayload) => Promise<void> | void;
};

export default function CreatePricingIndexModal({ setIsOpen, handleCreatePricingIndex }: Props) {
  const { t } = useTranslation();

  const { form, isSubmitting, errors, updateField, handleSubmit } = usePricingIndexForm({
    onSubmit: async (payload) => {
      await handleCreatePricingIndex(payload);
      setIsOpen(false);
    },
  });

  return (
    <TradingModal
      titleText={t('settings.pricingIndicesTab.modal.createTitle')}
      bodyText={
        <PricingIndexForm
          form={form}
          isSubmitting={isSubmitting}
          errors={errors}
          updateField={updateField}
          handleSubmit={handleSubmit}
          type="create"
        />
      }
      open
      onClose={() => setIsOpen(false)}
      styleModal={{
        minHeight: '35%',
        overflow: 'visible',
      }}
      shouldCloseOnBackdropClick={false}
    />
  );
}
